// ANALYTICS COMMON
export const NUCLEUS = 'nucleus';
export const STASH = 'stash';
export const MODULE_CLICK = 'content module click';
export const CLICKTHROUGH = 'clickthrough';
export const BUTTON_SUBMISSION = 'button submission';
export const INTERACTION = 'interaction';
export const SYSTEM = 'system';
export const ATC = 'atc';
export const PAGE_AB_TEST = 'hd home v1';
export const SEARCH_PAGE_AB_TEST = 'plp:version:gen2';
export const DEFAULT_BROWSE_CATEGORY_AB_TEST_L1 = 'category:l1:version:gen2';
export const DEFAULT_BROWSE_CATEGORY_AB_TEST_L2 = 'category:l2:version:gen2';
export const DUAL_PATH_AB_TEST = 'dual path';
export const PAGE_DEFAULT_TEMPLATE = 'default';
export const INSPIRATIONAL = 'inspirational';
export const PRODUCTS_AVAILABILITY = 'all products';
export const PLP_GRID = 'grid';
export const NO_FILTER = 'no filter';
export const PRODUCT_POD = 'product pod';
export const PRODUCT_VIEW = 'product view';
export const ONLINE_STORE = '8119';
export const CUSTOM_CATALOG = 'custom catalog';
export const NOT_CUSTOM_CATALOG = 'not custom catalog';
export const MAJOR_APPLIANCE = 'major-appliances';
export const MAGIC_APRON = 'magic apron';
export const MAGIC_APRON_BOT_SUBMIT_CLICK_EVENT = 'maa qna click';
export const MAGIC_APRON_ASSISTANT_SUBMIT_CLICK_EVENT = 'maa question submit';
export const B2B_MAJOR_APPLIANCE = 'b2b-major-appliances';
export const B2C = 'B2C';
export const B2B = 'B2B';
export const TABLE = 'Table';
export const TABLEVIEW = 'tableview';
export const MODULE = 'module';
export const RECS_CART_ADDITION_INFO = 'recommendation cart addition';
export const STRATEGY = 'project-based';
export const SECTION = 'dyn prod rec';
export const RECOMMENDATION_VERSION = 'v1';
export const CTL_RECOMMENDATION_VERSION = 'v1';
export const CTL_STRATEGY = 'ctl-decor';
export const RECOMMENDATION_EVENTNAME = 'recommendation pip load';
export const RECENTLY_VIEWED_EVENTNAME = 'recently viewed pip load';
export const SPONSORED_RECOMMENDATION_PIP_LOAD = 'sponsored recommendation pip load';
export const SP = 'sp';
export const HOMEPAGE_SPONSORED = 'hp_sponsored';
export const INSTANT_RECS_SCHEMA = 'instantrecomm';
export const INSTANT_RECOMMENDATION = 'Instant Rec Click';
export const INSTANT_CHECKOUT = 'instant checkout';
export const AUTOMOTIVE = 'automotive';
export const OVERLAY = 'overlay';
export const CLICK = 'click';
export const LIKE = 'like';
export const DISLIKE = 'dislike';
export const STANDARD = 'standard';
export const TRENDING = 'trending';
export const MY_ACCOUNT = 'my account';
export const MY_ACCOUNT_SETTINGS = 'my account settings';
export const ACCOUNT = 'account';
export const ERROR = 'error';
export const POST_PAGE_ERROR = 'post page error';
export const BODFS_CAR_SAME_DAY_DELIV = 'Get it delivered Today for $';
export const SCHEDULE_DELIV = 'Get it delivered as soon as ';

// For Search Pages ie /s
export const SEARCH = 'search';
export const SEARCH_RESULTS = 'search results';
export const SEARCH_SORTBY = 'best match';

// For Browse Pages ie /b
export const BROWSE = 'browse';
export const BROWSE_PAGE_PAGINATION = 'pagination';
export const BROWSE_PLP_MODULE = 'plp module';
export const BROWSE_SORTBY = 'top sellers';
export const BROWSE_RESULTS = 'browse results';

// For Collection Lists
export const COLLECTION_PAGETYPE_LIST_VIEW = 'collections:list view';
export const COLLECTION_PAGETYPE_INTEGRATED_BRANDS = 'collections:integrated';
export const COLLECTION_PAGETYPE_SPACE = 'collections:space';

// For decor pages
export const SUBCONTENTDECOR = 'subcontent_decor';
export const SIZE_GUIDE = 'size guide';
export const DROPDOWN = 'dropdown';
export const PIP = 'pip';
export const NOT_APPLICABLE = 'n/a';
export const NON_BUYABLE_REQUEST_A_QUOTE_PAGE_TYPE = 'tool:leadgen:pip';

// For Rental Pages
export const RENT_ONLINE_PIP_PAGE = 'tool:productrental:pip';
export const RENT_ONLINE_RESERVATION_PAGE = 'tool:productrental:reservation';

// For PIP Pages
export const PIP_SUB_CONTENT = 'pip sub-content';
export const SHARING = 'sharing';
export const TARGETED_MERCHANDISE = 'targeted merchandise';
export const LOCAL = 'local';
export const CONTENT = 'content';
export const MAGIC_PIP = 'magic pip';
export const BIP_PAGE = 'bip';
export const SHOPPABLE_IMAGES_DRAWER = 'shoppable images drawer';

// For Compare Pages
export const COMPARE = 'compare';
export const PRODUCT_COMPARISON = 'product comparison';

// For Gift Card Page
export const GIFT_CARD = 'gift card';
export const GIFT_CARD_PAGE_TYPE = 'gift card:pip';
export const GIFT_CARD_TYPE = 'pip';
export const GIFT_CARD_EVENT = 'gift card view';
export const GIFT_CARD_EVENT_MALL = 'gift card mall';
export const GIFT_CARD_MALL_FIRST = 'first party';
export const GIFT_CARD_MALL_SPECIALITY = 'specialty gift cards';
export const GIFT_CARD_BALANCE = 'check gift card balance';
export const GIFT_CARD_BALANCE_TYPE = 'gift card: check balance';
export const GIFT_CARD_BALANCE_EVENT = 'check balance';
export const GIFT_CARD_PROMO = 'GIFT_CARD';

// For Stylequiz
export const STYLEQUIZ_PAGETYPE_COLLECTION = 'collections:style quiz';
export const STYLEQUIZ_PRIMARY_CATEGORY = 'style quiz';

// For Exercise My Privacy Rights Page
export const EXERCISE_MY_PRIVACY_RIGHTS = 'exercise privacy rights';
export const MY_PREFERENCE_CENTER = 'my preference center';

// For Questions and Answers
export const QUESTIONS_AND_ANSWERS = 'questions and answers';

// Cart Pages
export const DD_PAGE_NAME = 'shopping cart';
export const DD_SITE_NAME = 'checkout';
export const DD_PAGE_EVENT = 'cart view';
export const EMPTY_CART = 'empty cart';

// Pages
export const STOREFINDER = 'storefinder';
export const COLLECTION = 'collection';
export const CATEGORY_PAGE = 'categorypage';
export const PEP = 'pep';
export const PLP = 'plp';
export const PACKAGES_PIP = 'ppip';
export const REBATE_CENTER = 'rebate center';
export const STORE_FINDER = 'store finder';
export const ARTICLE_EXPERIENCE = 'article';
export const ARTICLELIST_EXPERIENCE = 'alp';
export const OPT_OUT = 'opt out';
export const MY_HOMEPAGE = 'homepage';
export const MY_LIST_SUMMARY = 'account>lists';
export const MY_LIST_DETAILS = 'account>lists>list details';
export const PROJECTS = 'projects';
export const PROJECT_DETAILS = 'project details'
export const MY_LIST_SHARED = 'account>lists>list details>shared';
export const MY_LIST_DETAILS_PAGE_TYPE = 'maml: list details';
export const LISTS = 'lists';

// List Create Group Analytics Constants
export const LIST_CREATE_GROUP = 'list details: create group';

// Additional List Analytics Constants
export const LIST_EDIT_GROUP = 'list details: edit group';
export const LIST_SETTINGS = 'list settings';
export const LIST_EMAIL = 'email list';
export const LIST_PRINT = 'print list';
export const LIST_MAKE_NOTE = 'lists: make a note';

// List Builder Analytics Constants (PRO41-789)
export const LIST_BUILDER_OVERLAY_PREVIEW_LIST = 'preview list';

// List Builder Session Fields
export const AI_SESSION_ID_FIELD = 'aiSessionId';
export const AI_TEXT_ENTRY_FIELD = 'aiTextEntry';
export const LIST_STARTER_FIELD = 'listStarter';
// List analytics - new constants
export const LIST_VIEW_MODIFICATION = 'list view modification';
export const LIST_ADD = 'list add';
export const LIST_REMOVE = 'list remove';
export const LIST_PAGINATION_SETTINGS_PREFIX = 'lists: list details: pagination: ';
export const LIST_REARRANGE_PRODUCT = 'lists: list details: rearrange product';
export const LIST_NOTE_SAVED = 'lists: list details: product note saved';
export const LIST_FUNCTION_SELECT_ALL = 'list details: function: select all';
export const LIST_FUNCTION_DESELECT_ALL = 'list details: function: deselect all';
export const LIST_FUNCTION_COMPARE = 'list details: function: compare';
export const LIST_FUNCTION_EXPAND_ALL = 'list details: function: expand all';
export const LIST_FUNCTION_COLLAPSE_ALL = 'list details: function: collapse all';
export const COMMUNICATION_PREFERENCES = 'account>communication preferences';
export const MY_PREFERENCE_CENTER_PAGE = 'maml: my preference center';
export const BUYITAGAIN = 'buy it again page';
export const CART = 'cart';
export const EMBED_REGISTRATION = 'embed reg';
export const CLICK_HERE_LINK = 'click here link';
export const PACKAGE_SELECTION = 'package selection';
export const GIFT_CARDS = 'giftcard';
export const PO_JOB_NAMES = 'po job names';
export const PRICING_BENEFITS = 'pricing benefits';
export const PREFERRED_PRICING = 'preferred pricing';
export const PAINT_PURCHASE_HISTORY = 'paint purchase history';
export const SUBMISSION = 'submission';
export const MILITARY_DISCOUNT = 'military discount';
export const FLOORING_PROJECTS = 'flooring projects';
export const KITCHEN_VISUALIZER = 'kitchen visualizer';

// Projects Pages
export const PROJECTS_SUMMARY = 'account>projects';
export const PROJECTS_DETAILS = 'account>projects>project details';
export const PROJECTS_DETAILS_OVERVIEW = 'account>projects>project details>overview';
export const PROJECTS_DETAILS_MATERIALS = 'account>projects>project details>materials';
export const PROJECTS_SUMMARY_PAGE_TYPE = 'maml: projects';
export const PROJECTS_ENTRY_POINT = 'projects: entry point';
export const PROJECTS_SUMMARY_NO_PROJECTS = 'projects: no projects';
export const CREATE_GROUP = 'projects: create group';
export const PROJECTS_SUMMARY_NO_PROJECTS_INTERACTION = 'projects: no projects interaction';
// 7.51.46 Select Project Overlays
export const SELECT_PROJECT_ADD_TO = 'add-to.select-project';
// 7.51.49 MOBILE ONLY: Add To Overlay
export const ADD_TO_MOBILE = 'add-to.mobile';
export const SELECT_PROJECT_SUFFIX = ': select project';
export const SELECT_PROJECT_PLP_PREFFIX = 'plp';
export const SELECT_PROJECT_PROJECT_PREFFIX = 'project details';
export const EVENT_NAME_PREFIX_PROJECTS = {
  [BROWSE]: SELECT_PROJECT_PLP_PREFFIX,
  [SEARCH]: SELECT_PROJECT_PLP_PREFFIX,
  [PROJECTS]: SELECT_PROJECT_PROJECT_PREFFIX,
  [PIP]: PIP
};
// 7.51.29 Add to Project action w/NO new Group created
export const ADD_ITEM_PROJECT_W_NO_NEW_GROUP = 'project add';
export const ADD_ITEM_PROJECT_NEW_GROUP = 'new group project add';
export const ADD_ITEM_NEW_PROJECT_EVENT = 'new project project add';
export const ADD_ITEM_WITH_NEW_GROUP = 'projects: add to project action w/new group created';
export const ADD_ITEM_IN_EXISTING_GROUP = 'projects: add to project action w/NO new Group created';

// Localization project experience
export const PROJECT_ADD_DELIVERY_ZIPCODE_MESSAGING_ERROR = 'projects: show add delivery zipcode messaging';
export const PROJECT_SHOPPING_FOR_ERROR = 'projects: show shopping for message'
export const ADD_DELIVERY_ZIP_CLICK = 'projects: add delivery zip click';
export const DELIVERY_ZIP_OVERLAY = 'projects: delivery zip overlay';
export const DELIVERY_ZIPCODE_UPDATED = 'projects: delivery zipcode updated';
export const PROJECT_STORE_OVERLAY = 'projects: project store overlay';
export const SHOP_LOCATION_LINK_CLICK = 'projects: shop this location link click';
export const SHOPPING_IN_LINK = 'projects: shopping in link';

// Event Names
export const ARTICLE_LIST_PAGE = 'articlelistpage';
export const PAGINATION = 'pagination';
export const SORT = 'sort';
export const FILTER = 'filter';
export const PRIMARY_FILTER = 'primary_filter';
export const SMART_FILTER = 'smart-filter';
export const NO_EVENT = 'no_event';
export const SSKU = 'super_sku';
export const CHECK_AVAILABILITY = 'check fulfillment availability';
export const CART_ADD = 'cart add';
export const CART_ADD_LOCATION = 'cart add location';
export const CART_ADDITION_INFO = 'cart addition info';
export const CART_ADD_RECS = 'recommendation cart addition';
export const ADD_TO_CART_CLICK = 'add to cart click';
export const APPL_INSTALL_AND_HAUL_CART_ADD = 'appl install and haul cart add';
export const BUNDLE_APPL_P_S_CART_ADD = 'bundle appl p&s cart add';
export const PACKAGE_APPL_P_S_CART_ADD = 'package appl p&s cart add';
export const UGC_CLICK = 'ugc click';
export const CATEGORY_RECOMMENDATION = 'category recommendation';
export const ARTICLE_RECOMMENDATIONS = 'article recommendations';
export const SPONSORED_RECOMMENDATION_CART_ADDITION = 'sponsored recommendation cart addition';
export const SPONSORED_PROD_REC = 'sponsored prod rec';
export const GEN_MERCH_BUNDLE = 'gen merch bundle';
export const GEN_MERCH_PACKAGE = 'gen merch package';
export const BOGO_DRAWER_CLICK = 'bogo drawer';
export const BUNDLE_QUICK_VIEW = 'appl package quick view';
export const CLEAR_VERIFICATION_START = 'clearid verification start';
export const CLEAR_VERIFICATION_COMPLETE = 'clearid verification complete';
export const PLP_SUBCONTENT = 'plp sub-content';

// Business As Usual Badges
export const BADGE_MODELS_NEW = 'New';
export const BADGE_MODELS_SEASONAL = 'New This Season';
export const BADGE_MODELS_EXCLUSIVE = 'Exclusive';
export const BADGE_MODELS_TRENDING = 'Trending';
export const BADGE_MODELS_BEST_SELLER = 'Best Seller';
export const BADGE_MODELS_CUSTOM = 'Custom';
export const BADGE_MODELS_GUARANTEED = 'Guaranteed';
export const BADGE_MODELS_POPULAR = 'Popular on Pinterest';
export const BADGE_MODELS_CLEARANCE = 'in-store clearance messaging';
export const BADGE_MODELS_GIFT_CARD_PROMOTION = 'gift card promotion';

// eslint-disable-next-line
export const PAGE_LOAD_ERROR_MESSAGE = 'We\'re fixing it. Your search has found a page that\'s not responding. We\'ll have this patched up as soon as possible.';

// experience identifier
export const NON_BUYABLE_REQUEST_A_QUOTE = 'non-buyable-service-request-a-quote';
export const NON_BUYABLE_SERVICES = 'non-buyable-services';
export const RENT_ONLINE = 'rent-online';

// domain lists
export const DEFAULT_PRODUCT_DOMAINS = ['badges', 'identifiers', 'fulfillment', 'taxonomy', 'pricing', 'subscription'];
export const APPLIANCE_PRODUCT_DOMAINS = ['badges', 'identifiers', 'fulfillment', 'taxonomy', 'pricing'];
export const RENTAL_PRODUCT_DOMAINS = ['identifiers', 'details', 'media', 'taxonomy'];
export const RENTAL_RESERVATION_DOMAINS = ['identifiers', 'media', 'taxonomy'];
export const NON_BUYABLE_SERVICES_PRODUCT_DOMAINS = ['identifiers', 'details', 'media', 'taxonomy'];

// schema lists
export const RECS_SCHEMA_LIST = ['DynamicRecsComponent[0]', 'CategoryCarousel[0]', 'UserDataServices[0]',
  'SearchViewedRecs[0]', 'RecentlyViewed[0]', 'RecommendationsProductPodCarousel[0]',
  'RecommendationsProductPodCarousel[1]', 'CompleteTheLookProductPodCarousel[0]',
  'PlpRecsRenderPlaceholder[4]', 'InstantRecs[0]',
  'InstantRecsContainer[0]', 'ReorderRecommendations[0]', 'TodaysRecommendations[0]', 'SupplementalRecs[0]'];

// For AddT0
export const CREATE_LIST = 'create list';
export const ADD_TO_PREFIX = {
  [MY_LIST_DETAILS]: LISTS,
  [PROJECTS_DETAILS_MATERIALS]: PROJECTS,
  [PROJECTS]: PROJECTS,
  [PROJECT_DETAILS]: PROJECTS
};

export const ADD_TO_SCREEN = {
  'MINI_PIP_BASE': 'mini pip',
  'MINI_PIP_PRODUCT_OVERVIEW': 'mini pip: overview',
  'MINI_PIP_PRODUCT_SPECS': 'mini pip: specifications',
  'MINI_PIP_PRODUCT_REVIEWS': 'mini pip: reviews',
  'MINI_PIP_FULL': 'mini pip: full',
  'MINI_PLP': 'mini plp',
  'INTENTS_PREVIEW': 'ai intents preview'
};

// For AddToQuote
export const ADD_TO_QUOTE = 'add to quote';
export const CREATE_A_QUOTE = 'add to quote create a quote';
export const QUOTE_ADD = 'quote add';
export const NEW_QUOTE_ADD = 'new quote add';

// For BuyItAgain
export const BIA_MY_ACCOUNT = MY_ACCOUNT_SETTINGS;
export const BIA_FILTER_BY = 'buy it again: filter by ';
export const BIA_SEARCH = 'buy it again: search';
export const BIA = 'buy it again';
export const BIA_PAGE_TYPE = 'maml:buy it again';
export const BIA_CATEGORY = 'account';
export const BIA_SUBCATEGORY1 = 'account>buy it again';
export const BIA_SUBCATEGORY2 = 'account>buy it again';
export const BIA_SUBCATEGORY2_PAGINATION = 'account>buy it again>pagination';
export const BIA_PAGE_NAME_PAGINATION = 'account>buy it again>pagination';
export const BIA_CARD_VIEW = 'buy it again: card view';
export const BIA_TABLE_VIEW = 'buy it again: table view';
export const BIA_REORDER = 'reorder';

// component path identifiers
export const SPECIAL_BUY_BANNER = 'SpecialBuyBanner\\[';
export const ITEM_RELATED_GROUPS = 'itemrelatedgroups\\[';
export const CURATION = 'curation\\[';
export const VISUAL_RECS = 'visualrecommendations\\[';
export const SHOP_BY_ROOM_COLLECTION = 'shopbyroomcollection';
export const RECOMMENDATIONS = 'recommendationsproductpodcarousel\\[';
export const INSTANT_RECOMMENDATIONS_GRID = 'instantrecs\\[';
export const SEARCH_RECOMMENDATION = 'PlpRecsRenderPlaceholder\\[';
export const CTL_RECOMMENDATIONS = 'completethelookproductpodcarousel\\[';
export const MORE_IN_THIS_COLLECTION = 'product-section-collections';
export const SUPPLEMENTAL_RECOMMENDATIONS = 'SupplementalRecs\\[';
export const SWIPER_SLIDE = 'SwiperSlide\\[';
export const BUY_IT_AGAIN = 'ReorderRecommendations\\[';
export const TODAYS_RECS = 'TodaysRecommendations\\[';
export const PRICE_DROP = 'PriceDrop\\[';

// path to pro network
export const PATH_TO_PRO = 'path to pro';
export const PATH_TO_PRO_NETWORK = 'path to pro network';
export const PATH_TO_PRO_NETWORK_UNAVAILABLE = 'path to pro network>unavailable';
export const PTP_DASHBOARD_WIDGET_ID = 'ptpdashboard';
export const PTP_JOB_APPLICANTS_WIDGET_ID = 'job applicants';
export const PTP_JOB_POSTING_ACTIONS_WIDGET_ID = 'job posting actions';
export const PTP_PROFILE_SEARCH_WIDGET_ID = 'profile search';
export const PTP_LANDING_PAGE_WIDGET_ID = 'landing page';
export const PTP_PROFILE_WIDGET_ID = 'profile';
export const PTP_PROFILE_OVERLAY_WIDGET_ID = 'profile overlay';
export const PTP_HIRING_WIDGET_ID = 'hiring';
export const PATH_TO_PRO_MY_DASHBOARD = 'my dashboard';
export const PATH_TO_PRO_PROFILE_SEARCH = 'profile search';
export const PATH_TO_PRO_CANDIDATE_SEARCH = 'candidate search';
export const PATH_TO_PRO_CANDIDATE_PAGE = 'candidate page';
export const PATH_TO_PRO_JOB_POSTINGS = 'job postings';
export const PATH_TO_PRO_JOB_POSTING_DETAILS = 'job posting details';
export const PATH_TO_PRO_JOB_APPLICANTS = 'job applicants';
export const SUBCONTENT_PTP = 'subcontent_ptp';
export const PTP_COMPONENT = 'ptp';
export const ACTION = 'action';

// self-service
export const SELF_SERVICE = 'self service';
export const SELF_SERVICE_PROPANE = 'self service>propane tanks';
export const EMPTY = '';
export const LIST = 'list';

// quick-view

export const MERCHANDISE = 'MERCHANDISE';
export const MAJOR_APPLIANCES_UPPERCASE = 'MAJOR_APPLIANCE';

// Product-pod parent names
export const IRG = 'irg';
export const RECENTLY_VIEWED = 'recently-viewed';
export const SPONSORED_CAROUSEL = 'sponsored-carousel';
export const RECS_PRODUCT_POD_CAROUSEL = 'recs-product-pod-carousel';
export const RECS_DTS_PRODUCT_POD_CAROUSEL = 'recs-dts-product-pod-carousel';
export const INSTANT_RECS = 'instant-recs';
export const PLP_RECS_PLACEHOLDER = 'plp-recs-placeholder';
export const SUPPLEMENTAL_RECS = 'supplemental-recs';
export const FBT_CAROUSEL = 'fbt-carousel';
export const APL_BUNDLE = 'appliance-bundle';
export const VISUAL_RECOMMENDATION = 'visual-recommendation';
export const SBR_COLLECTION = 'sbr-collection';
export const IBT_BATH_COLLECTION = 'ibt bath collection';
export const SPECIAL_BUY_BANNER_CAROUSEL = 'special-buy-banner';
export const CURATION_CAROUSEL = 'curation';
export const MORE_IN_THIS_COLLECTION_SECTION = 'more-in-this-collection';
export const PROJECT_SHOPPING = 'project-shopping';
export const DISCOVERY_ZONES = 'discovery-zones';
export const DISCOVERY_ZONES_BUYITAGAIN = 'buyitagain';
export const FEATURE_BASED_RECOMMENDATIONS = 'feature-based-recommendations';

// order-sample
export const ORDER_SAMPLES = 'order samples';

// bath landing page names
export const BDS = 'bathroom design studio';
export const BDS_PAGE_TYPE = 'bathroom design studio:contents';

// parts-and-services
export const PARTS_AND_SERVICES = 'parts and services';
export const HDPP_OPTIONS_DRAWER = 'hdpp options drawer';
export const HDPP_CART_ADD = 'hdpp cart add';
export const APPL = 'appl';

// quote-details page names

export const DELIVERY_ZIP_UPDATE_EVENT = 'quote details page: updated zip code';
export const DELIVERY_ZIP_OVERLAY_EVENT = 'quote details: enter delivery zip code';

// quote-dashboard page names
export const REFRESH_QUOTE_INFO_OVERLAY_EVENT = 'whats new refresh quote';

//  Dashboard
export const ACCOUNT_DASHBOARD_CLICK = 'account dashboard click';

// Appliance Fuel Type
export const APPLIANCE_FUEL_TYPE_DRAWER = 'how to check if you need gas or electric';

// Fit Compatibility
export const FIT_COMPATIBILITY = 'fit compatibility';
export const FIT_COMPATIBILITY_STEP4 = 'fit compatibility: step 4 decide on depth';
export const FIT_COMPATIBILITY_DRAWER = 'fit compatibility: appl make sure it fits';
export const FIT_COMPATIBILITY_DRAWER_CALCULATE_FIT = 'calculate fit';

// services quote quote details
export const SERVICES_QUOTE = 'services quote';
export const SERVICES_QUOTE_DETAILS = 'services quote>quote details';
export const QUOTE_DETAILS = 'quote details';
export const SERVICES_QUOTE_MODIFY = 'services quote>view quote>modify quote';
export const SERVICES_DISCOUNT_DETAILS = 'services quote>view quote>discount details';
export const SERVICES = 'services';
export const SERVICES_SIGN_IN_OTP = 'services>sign in otp';
export const SERVICES_SIGN_IN = 'services: sign in';
export const SERVICES_SIGN_IN_OTP_ENTER_CODE = 'services>sign in otp>enter code';

// Orange Lens
export const ORANGE_LENS = 'orangelens';
export const ORANGE_LENS_TYPE = 'reverse image results';
export const ORANGE_LENS_SHOPPABLE_IMAGES_HOTSPOTS = 'orangelens shoppable image hotspot';

// HD pass
export const HD_PASS = 'cards and accounts: hd pass';

// Services Online Express
// Device width mapping for responsive analytics
export const PAGE_WIDTH_MAP = [
  { size: 768, name: 'desktop' },
  { size: 544, name: 'tablet' },
  { size: 0, name: 'mobile' },
];

// Base category names for services online express
export const SERVICES_ONLINE_EXPRESS_BASENAMES = {
  CATEGORY: 'installation services and repair',
  SUBCATEGORY: 'installation services and repair',
  PAGE: 'installation services and repair',
  FORM: 'installation services and repair',
  IFRAME_PAGELOAD: 'request a quote',
  FORMTYPE: 'installation services',
};
